import React from "react"

import {  Wrapper, Background, Padder, RichText } from 'components'

import {Layout, Viewport, BlockDescription} from "../../components"
import { getBlockDescriptionProps } from '../../utility'

import theme from '../../style/theme'

export default (props) => {

  const { translations, siteMetadata } = props.pageContext

  const { blockDescription_3, richText_3 } = translations
  const { pathPrefix} = siteMetadata

  return (
  <Layout {...props}>
    <Wrapper size="large">
    <Padder size="big">
      <RichText text={richText_3} />
    </Padder>

    </Wrapper>
    {blockDescription_3.map((item, index) => (
        <Background color={index % 2 ? "white" : theme.colors.lightGray.secondary} key={`${item.title}${index}`}>
          <Wrapper size="large">
            <Padder size="big">
              <Viewport>
                {() => {
                  const props = getBlockDescriptionProps({item, index, pathPrefix})
                  return <BlockDescription {...props} />
                }}
              </Viewport>
            </Padder>
          </Wrapper>
        </Background>
      ))}
  </Layout>
)}